import ModalVersoes from "../../../components/Previa/ModalVersoes";
import { usePreviaIcms } from "../PreviaIcmsContext";

const ModalVersoesIcms = ({
  open,
  onClose,
  idPrevia,
  tipoPrevia,
  isProjeto,
  dadosEmpresa,
}) => {
  return (
    <ModalVersoes
      open={open}
      onClose={onClose}
      idPrevia={idPrevia}
      tipoPrevia={tipoPrevia}
      isProjeto={isProjeto}
      contextHook={usePreviaIcms}
      dadosEmpresa={dadosEmpresa}
    />
  );
};

export default ModalVersoesIcms;
